import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const SystemMessageSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};

  .form-container {
    padding: 0px 0px 24px 16px;
    ${responsive.MOBILE`
      padding: 16px 8px;
    `};
  }

  .reset-all-button {
    margin-right: 10px;
  }

  .responsive-search-btn-container,
  .form-header-right {
    padding-right: 12px;
    ${responsive.MOBILE`
      padding-right: 8px;
    `};
  }

  .search-button-container {
    .search-button {
      margin-top: 29px;
      ${responsive.MOBILE`
      width: 100%;
    `};
    }
    ${responsive.MOBILE`
      width: 100%;
    `};
  }
`;
